export default {
  CHECKOUT: {
    TERMS_AND_CONDITIONS: 'Terms and Conditions',
    READ_AND_ACCEPT: 'I have read and accept ',
    OF_PRODUCT: ' of ',
    TERMS_DOWNLOAD_FAILED: 'Failed to get T&C document. Please try again or contact support.',
  },
  SUBSCRIPTIONS: {
    CATEGORY: 'Category',
    REGION: 'Region',
    GLOBAL: 'Global',
    SEGMENT: 'Segment',
    ALL: 'All',
    INDUSTRY: 'Industry',
    VARIOUS: 'Various',
    SUBSCRIBED: 'Subscribed',
    GET_FREE_TRIAL: 'Get free Trial',
    GET_STARTED: 'Get started',
    MORE_INFO: 'More info',
    ADD_TO_BASKET: 'Add to basket',
  },
};
